<div class="flex flex-col w-full gap-1 menu-group">
  <button
    class="group transition-colors duration-150 relative hover:bg-base-200"
    [attr.data-active]="active()"
    [attr.data-collapsed]="collapsed()"
    (click)="handleClick($event)"
    [class.border-l-4]="!collapsed()"
    [class.border-transparent]="!collapsed() && !active()"
    [class.bg-primary/10]="active()"
    [class.text-primary!]="active()"
    [class.border-primary!]="active() && !collapsed()">
    <span [class]="icon() + ' size-5! shrink-0'"></span>
    @if (!collapsed()) {
      <div class="text-sm font-medium whitespace-nowrap overflow-hidden">
        {{ label() }}
      </div>
      <span
        class="icon-[mdi--chevron-down] size-5! transition-transform duration-200 shrink-0 ml-auto"
        [class.rotate-180]="isOpen()"
        [class.text-primary]="active()"
        [class.text-base-content/40]="!active()"></span>
    }
  </button>

  <!-- 하위 메뉴 컨테이너 (인라인 / 플라이아웃 공용) -->
  <div #childrenContainer class="relative flex flex-col w-full gap-1" [class.hidden]="!isInlineVisible()">
    @if (!collapsed()) {
      <div class="absolute w-px h-full bg-base-300 left-6"></div>
    }
    <ng-content />
  </div>
</div>
